import React from 'react';
import styles from './sections.module.css';
import SnapTour from '../SnapTour';
import {
  TapIcon,
  ContactIcon,
  MapPinIcon,
  SearchIcon,
} from '../MarketingIcons';

/**
 * Four live stages of a Velox introduction.
 *
 * Automated follow-up is being built from the record these stages already
 * capture; it is not a numbered step here, because that would climax the
 * journey on something that does not ship today.
 */
const STEPS = [
  {
    id: 'share',
    Icon: TapIcon,
    title: 'Share',
    body: 'Your profile opens on their phone. Tap a card, or send a link. Nothing to install.',
  },
  {
    id: 'capture',
    Icon: ContactIcon,
    title: 'Capture',
    body: 'They send their details back in a moment, Velox account or not.',
  },
  {
    id: 'remember',
    Icon: MapPinIcon,
    title: 'Remember',
    body: 'Where, when, and what you noted. When they update their details, your copy updates too.',
  },
  {
    id: 'continue',
    Icon: SearchIcon,
    title: 'Continue',
    body: 'Find them when they matter. See what your networking produced.',
  },
];

const StepCard = ({ Icon, title, body, index }) => (
  <div className={styles.flowStep}>
    <div className={styles.flowStepHead}>
      <span className={styles.flowIcon}>
        <Icon />
      </span>
      <span className={styles.flowNumber}>
        STEP {String(index + 1).padStart(2, '0')}
      </span>
    </div>
    <h3>{title}</h3>
    <p className="vxm-body">{body}</p>
  </div>
);

const FlowDiagram = () => (
  <SnapTour
    slides={STEPS}
    ariaLabel="How Velox works"
    layout="grid"
    renderSlide={(step, index) => (
      <StepCard
        Icon={step.Icon}
        title={step.title}
        body={step.body}
        index={index}
      />
    )}
  />
);

export default FlowDiagram;
